export const getErrorMessageFromResponse = (error: any): string => {
  const message = error?.message;

  if (Array.isArray(message) && message.length) {
    return message[0];
  }

  if (typeof message === "string" && message.trim()) {
    return message;
  }

  const responseMessage = error?.response?.message;

  if (Array.isArray(responseMessage) && responseMessage.length) {
    return responseMessage[0];
  }

  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return responseMessage;
  }

  const dataMessage = error?.response?.data?.message;

  if (Array.isArray(dataMessage) && dataMessage.length) {
    return dataMessage[0];
  }

  if (typeof dataMessage === "string" && dataMessage.trim()) {
    return dataMessage;
  }

  return "Failed to create challenge";
};
